import React from "react";
import PropTypes from "prop-types";
import "./Tabs.css";

const Tabs = ({
  tabs,
  activeTab,
  onChange,
  variant = "line",
  color = "primary",
  className = "",
  ...props
}) => {
  return (
    <div className={`app-tabs-container ${className}`.trim()} {...props}>
      <div className={`app-tabs-list variant-${variant} color-${color}`}>
        {tabs.map((tab) => (
          <button
            key={tab.id}
            type="button"
            className={`app-tab-item ${activeTab === tab.id ? "active" : ""} ${tab.hasError ? "has-error" : ""}`}
            onClick={() => onChange(tab.id)}
            title={tab.description || tab.label}
          >
            {tab.icon && <span className="tab-icon" style={{ display: "flex", alignItems: "center" }}>{tab.icon}</span>}
            <span className="tab-label">{tab.label}</span>
            {tab.hasError && (
              <span
                style={{
                  width: "7px",
                  height: "7px",
                  borderRadius: "50%",
                  backgroundColor: "#ef4444",
                  display: "inline-block",
                  marginLeft: "2px"
                }}
                title="Tab has validation errors"
              />
            )}
            {tab.badge !== undefined && tab.badge !== null && (
              <span className="badge-pill">{tab.badge}</span>
            )}
          </button>
        ))}
      </div>
    </div>
  );
};

Tabs.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      icon: PropTypes.node,
      badge: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      description: PropTypes.string,
    })
  ).isRequired,
  activeTab: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  variant: PropTypes.oneOf(["line", "pills", "flat"]),
  color: PropTypes.oneOf(["primary", "secondary"]),
  className: PropTypes.string,
};

export default Tabs;
